<template>
    <div>
        <div class="row mb-6">
            <div class="col-6 d-flex justify-content-start">
                <v-card-title>{{ $t('orders.orderDetails') }} </v-card-title>
            </div>
            <div class="col-6 d-flex justify-content-end">
                <genericBtnComponent v-if="tab === 'option-1'" :Title="$t('orders.downloadPdf')"
                    @click="downloadOrderPdf" />
            </div>
        </div>
    </div>

    <v-card flat>
        <v-tabs v-model="tab" background-color="transparent" color="basil" grow fixed-tabs>
            <v-tab class="slider" value="option-1" :style="NotActive" centered v-model="general">
                {{ $t('suppliers.general') }}</v-tab>
            <v-tab class="slider" value="option-3" :style="NotActive" centered v-model="general">
                {{ $t('suppliers.validation') }}</v-tab>
        </v-tabs>

        <v-divider class="ma-0"></v-divider>
        <v-window v-model="tab" :key="tab">
            <v-window-item value="option-1">
                <order-general-information-tab ref="generalInformationListRef" @update-id-command="updateIdCommand" />
            </v-window-item>
            <v-window-item value="option-3">
                <order-validation-tab ref="ValidationListRef" />
            </v-window-item>
        </v-window>
    </v-card>
</template>
<script>
import OrderGeneralInformationTab from "./OrdersEdit/OrderGeneralInformationTab.vue";
import OrderValidationTab from "./OrdersEdit/OrderValidationTab.vue";
import genericBtnComponent from "@/genericComponent/genericBtnComponent.vue";
import { getOrderPdf } from "@/api/index";

export default {
    mounted() {
        document.title = window.VUE_APP_NAME + ' - ' + this.$t('Document.Title.Orders');
    },
    name: "OrdersDetails",
    components: {
        OrderGeneralInformationTab,
        OrderValidationTab,
        genericBtnComponent

    },
    data: () => ({
        idCommand: null,
        tab: "option-1",
        general: true,
        step: 1,
        NotActive: {
            color: "#667280",
            fontSize: "14px",
            font: "inter",
        },
        canEditGeneralInformation: false,
        isDisabled: {
            type: Boolean,
            default: false
        },
    }),
    created() {
    },
    methods: {
        updateIdCommand(id) {
            this.idCommand = id;
        },
        getParent(name) {
            let p = this.$parent;
            while (typeof p !== 'undefined') {
                if (p.$options.name == name) {
                    return p;
                } else {
                    p = p.$parent;
                }
            }
            return false;
        },
        async downloadOrderPdf() {
            try {
                const response = await getOrderPdf(this.idCommand);
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `Order_${this.numCommand}.pdf`);
                document.body.appendChild(link);
                link.click();
                link.remove();
            } catch (error) {
                console.error("Error downloading PDF:", error);
                this.$toast.error(this.$t("orders.errorDownloadPdf"));
            }
        },
    },
}
</script>
<style scoped>
.v-card-title {
    color: #001e50;
    font-size: 18px;
    line-height: 25.5px;
    font-weight: 700;
    font-family: inter;
}

.text-basil {
    color: #114ef7 !important;
    font-size: 14px;
    line-height: 20px;
    font-weight: 600;
    font-family: inter;
}

.slider {
    font-family: 'Inter';
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;
    flex: content;
    border-bottom: "2px solid black";
}

.disabled {
    opacity: 0.5;
    pointer-events: none;
}
</style>